
import { ReactNode } from "react";

// Function to format bold text (**text** or *text*)
export const formatBoldText = (text: string): string | ReactNode[] => {
  if (!text) return text;
  
  // Look for patterns like **text** or *Key Points:**
  const parts: (string | JSX.Element)[] = [];
  let currentIndex = 0;
  
  // First replace double asterisks format (**text**) with bold elements
  const boldRegex = /\*\*(.*?)\*\*/g;
  let match;
  
  while ((match = boldRegex.exec(text)) !== null) {
    // Add text before the match
    if (match.index > currentIndex) {
      parts.push(text.substring(currentIndex, match.index));
    }
    
    // Add the bold text
    parts.push(<strong key={`bold-${match.index}`} className="font-semibold">{match[1]}</strong>);
    
    // Update current index
    currentIndex = match.index + match[0].length;
  }
  
  // Add any remaining text
  if (currentIndex < text.length) {
    parts.push(text.substring(currentIndex));
  }
  
  // Handle cases with single asterisks that are likely meant to be bold
  // like *Key Points:* or *Next Steps:*
  if (parts.length === 0 && /^\*(.*?):\*/.test(text)) {
    const headerMatch = /^\*(.*?):\*(.*)/.exec(text);
    if (headerMatch) {
      // Return array of nodes instead of a JSX fragment
      return [
        <strong key="header-bold" className="font-semibold">{headerMatch[1]}:</strong>,
        headerMatch[2]
      ];
    }
  }
  
  return parts.length > 0 ? parts : text;
};
